<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Problemática</h4>
            </div>
            <br>
            <div class="card-body">
                <div id="botonCrearCliente">
                    <button class="btn btn-block btn-secondary col-sm-12 col-lg-2 float-right" type="button" (click)="modalGenerarTicket()">Generar Ticket</button>
                    <!-- *ngIf="usuario.rol !== 'SOPORTE'" -->
                </div>
                <!-- ================================ -->
                <!-- ===== Modal Ticket Generar ===== -->
                <!-- ================================ -->
                <div class="modal fade" id="tickeGenerar" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="float float-right">Descripción de problema</h4>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <FORM class="form-horizontal form-material">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <label>Id Team Viewer: </label>
                                            <input class="form-control" type="text" name="tviewerId" [(ngModel)]="teamViewerId" [dropSpecialCharacters]="true" mask="0000 0000 0000">
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Contraseña de Team Viewer:  <span class="help"> </span></label>
                                            <input class="form-control letras" type="text" name="tviewerPass" [(ngModel)]="teamViewerPass">
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Modem (SSID): <span class="help"> </span></label>
                                            <input class="form-control letras" type="text" name="modemSS" [(ngModel)]="modemSSID">
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Contraseña de Modem: <span class="help"> </span></label>
                                            <input class="form-control letras" type="text" name="modemPas" [(ngModel)]="modemPass">
                                        </div>
                                        <!-- Documento contrato -->
                                        <div class="col-sm-6">
                                            <!-- Concepto -->
                                            <label class="col-md-6">Concepto* </label>
                                            <div class="col-md-8">
                                                <select class="form-control" style="text-align: center; width: 270px" name="conceptId" [(ngModel)]="conceptoId" (ngModelChange)="conceptoAdmin()">
                                                    <option value="1">Adminpaq</option>
                                                    <option value="2">Camaras</option>
                                                    <option value="3">Impresoras</option>
                                                    <option value="4">Cableado</option>
                                                    <option value="5">Telefonos</option>
                                                    <option value="6">Facturas</option>
                                                    <option value="7">Solicitudes de equipo</option>
                                                    <option value="8">Cotizaciones</option>
                                                    <option value="9">Mantenimiento de equipo</option>
                                                    <option value="10">Checadores</option>
                                                    <option value="11">AspelNoi</option>
                                                    <option value="12">Toner</option>
                                                    <option value="13">Prestamos de equipos</option>
                                                    <option value="14">Correos</option>
                                                    <option value="15">Admin Almacenes</option>
                                                    <option value="16">Otros</option>
                                                    <option value="17" >Desarrollo/plataforma/sm8-betaSoft</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-sm-6" *ngIf="boolfolioFactura">
                                            <label>Concepto de factura:  <span class="help"> </span></label>
                                            <select class="form-control" style="text-align: center; width: 270px" name="cFacturaId" [(ngModel)]="conceptoFacturaId">
                                                <option value="1">Venta/Pagada</option>
                                                <option value="2">Venta/No pagada</option>
                                                <option value="3">Servicio/Pagada</option>
                                                <option value="4">Servicio/No pagada</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-6" *ngIf="boolfolioFactura">
                                                <label>Folio de factura:  <span class="help"> </span></label>
                                                <input class="form-control letras" type="text" name="fFactura" [(ngModel)]="folioFactura">
                                            </div>
                                        <div class="col-md-12">
                                            <label>Descripción del problema</label>
                                            <textarea class="form-control areaComentario" rows="6" cols="100" name="descrip" [(ngModel)]="descripcion"></textarea>
                                        </div>
                                        <div class="form-group col-sm-12 col-md-12 col-lg-12" id="divContrato">
                                                <label class="control-label text-left col-6 col-sm-6 col-md-6 col-lg-6">Captura de imagen del problema</label>
                                                <div class="col-md-12">
                                                    <input type="file" multiple="multiple" class="archivoCaptura btn btn-outline-info" name="problema" data-show-loader="true" data-allowed-file-extensions="pdf png jpg" data-max-file-size="5M" />
                                                </div>
                                            </div>
                                    </div>
                                </FORM>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-info waves-effect botonconfirmar" type="button" data-dismiss="modal" (click)="enviarTicket()" routerLink="/dashboard/tickets/0">
                                    Enviar Ticket
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ================================ -->
                <!-- ===== Modal Ticket Generar ===== -->
                <!-- ================================ -->
                    <!-- class="losTickets" -->
                    <br>
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered tablaTickets" cellspacing="0">
                        <thead>
                            <tr style="text-align:center">
                                <th>Id</th>
                                <!-- style="display:none;" -->
                                <th>Concepto</th>
                                <th>Sucursal</th>
                                <th>Usuario</th>
                                <th>Asesor técnico</th>
                                <th>Mostrar</th>
                                <th>Estatus</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style="text-align:center" *ngFor="let ticket of arrayTickets">
                                <th> {{ ticket.id }} </th>
                                <!-- style="display:none;" -->
                                <th> {{ ticket.concepto }} </th>
                                <th> {{ ticket.sucursal }} </th>
                                <th> {{ ticket.usuario }} </th>
                                <th> {{ ticket.asesor }} </th>
                                <th>
                                    <span class="label" [style.background]="ticket.estatusColor">{{ ticket.estatusNombre }}</span>
                                </th>
                                <th>
                                    <button class="btn detallesTicket" data-toggle="modal" data-target="#tickeDetalles" (click)=detallesTicket(ticket.aidi)>Detalles</button>
                                    <!-- data-toggle="modal" data-target="#tickeDetalles" -->
                                </th>
                            </tr>
                        </tbody>
                    </table>
                <br>
                <hr>
                <br>
                <!-- ==================== -->
                <!-- ===== GRÁFICAS ===== -->
                <!-- ==================== -->
                <h3 *ngIf="this.usuario.rol === 'SOPORTE'">Gráficas:</h3>
                <br>
                <div class="col-md-6 float float-left" style="height: 550px; width: 720px;">
                    <canvas id="lineChart"></canvas>
                </div>
                <div class="col-md-6 float float-right" style="height: 550px; width: 720px;">
                    <canvas id="lineChart2"></canvas>
                </div>
                <!-- ==================== -->
                <!-- ===== GRÁFICAS ===== -->
                <!-- ==================== -->
                <!-- ======================================= -->
                <!-- ========= Detalles del Ticket ========= -->
                <!-- ======================================= -->
                <div class="modal fade" id="tickeDetalles" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header" [style.background-color]="colorTicketTitulo">
                                <!--  [style.background-color]="statusCliente.color" -->
                                <h4 class="float float-right">Detalles del Ticket</h4>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <FORM class="form-horizontal form-material">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <label><strong>Asesor: </strong></label>
                                            <label>{{ detallesAsesor }}</label>
                                            <br>
                                            <label><strong>Concepto: </strong></label>
                                            <label>{{ detallesConcepto }}</label>
                                            <br>
                                            <label><strong>Sucursal: </strong></label>
                                            <label>{{ detallesSucursal }}</label>
                                            <br>
                                            <label><strong>Solicitud: </strong></label>
                                            <label>{{ detallesSolicitud }}</label>
                                        </div>
                                        <div class="col-sm-6">
                                            <label><strong>Team Viewer Id: </strong></label>
                                            <label>{{ detallesTeam }}</label>
                                            <br>
                                            <label><strong>Team Viewer password: </strong></label>
                                            <label>{{ detallesTeamPass }}</label>
                                            <br>
                                            <label><strong>Modem: </strong></label>
                                            <label>{{ detallesModem }}</label>
                                            <br>
                                            <label><strong>Modem password: </strong></label>
                                            <label>{{ detallesModemPass }}</label>
                                        </div>
                                    </div>
                                </FORM>
                                <br>
                                <div class="docs" *ngIf="banderaOtrosDocs">
                                        <hr>
                                        <h3>Documentos y archivos:</h3>
                                        <div *ngFor="let doc of documentosImg; let i=index">
                                                <a href="{{doc.url}}" target="_blank"><font style="color: black"> archivo &nbsp;{{i+1}}</font></a>
                                        </div>
                                    </div>
                                <!-- ==================== -->
                                <!-- ===== Imágenes ===== -->
                                <!-- ==================== -->
                                <div class="imgSrc" *ngIf="banderaImgTickets">
                                    <hr>
                                    <h3>Imágenes:</h3>
                                    <ngx-gallery [options]="galleryOptions" [images]="galleryImages"></ngx-gallery>
                                </div>
                                <!-- ==================== -->
                                <!-- ===== Imágenes ===== -->
                                <!-- ==================== -->
                                
                                <!-- ==================== -->
                                <!-- Comentario de ticket -->
                                <!-- ==================== -->
                                <!-- Botones -->
                                <br>
                                <div>
                                    <hr>
                                    <label>Mostrar comentarios</label>
                                    <button class="btn btn-circle mostrarOcultar" (click)="mostrarAreaComentario()"><i class="mdi mdi-chevron-double-down"></i></button>
                                    <label>Ocultar comentarios</label>
                                    <button class="btn btn-circle mostrarOcultar" (click)="ocultarAreaComentario()"><i class="mdi mdi-chevron-double-up"></i></button>
                                </div>
                                <br>
                                <!-- Botones -->
                                <div >
                                        <div id="AreaDelComentario" *ngIf="arrayComentarioTicket.length !== 0" class="row row-broken">
                                          <div class="col-sm-12 col-xs-12 chat" style="overflow-x:auto; overflow-y:auto;" tabindex="5001">
                                            <div class="col-inside-lg decor-default">
                                                <div >
                                              <div class="chat-body" *ngFor="let mensaje of arrayComentarioTicket">
                                                <div *ngIf="mensaje.comentario.usuario.username !== usuario.userName; else nopeYo" class="answer left">
                                                  <div class="avatar">
                                                    <img src="{{ API.imagenesPerfil + mensaje.comentario.usuario.imagenPerfil }}" alt="User name">
                                                    <div class="status offline"></div>
                                                  </div>
                                                 <div class="name">{{mensaje.comentario.usuario.username}}</div>
                                                  <div *ngIf="mensaje.tipo === 'TEXTO'; else comentImagen" class="text">
                                                    {{mensaje.comentario.comentario}}
                                                  </div>
                                                  <ng-template #comentImagen>
                                                      <a target="_blank" href="{{mensaje.comentario.comentario}}"><img src="{{mensaje.comentario.comentario}}" alt="imagen Chida" width="250" height="250" ></a>
                                                      
                                                  </ng-template>
                                                  
                                                  <div class="time">fecha: &nbsp;{{mensaje.comentario.fecha}} &nbsp; hora: {{mensaje.comentario.hora}}</div>
                                                </div>
                                                <ng-template #nopeYo>
                                                        <div class="answer right">
                                                                <div class="avatar">
                                                                  <img src="{{ API.imagenesPerfil + mensaje.comentario.usuario.imagenPerfil }}" alt="User name">
                                                                  <div class="status offline"></div>
                                                                </div>
                                                                <div class="name">{{mensaje.comentario.usuario.username}}</div>
                                                                <div *ngIf="mensaje.tipo === 'TEXTO'; else comentImagen2" class="text">
                                                                        {{mensaje.comentario.comentario}}
                                                                      </div>
                                                                      <ng-template #comentImagen2>
                                                                            <a target="_blank" href="{{mensaje.comentario.comentario}}"><img src="{{mensaje.comentario.comentario}}" alt="imagen Chida" width="250" height="250" ></a>
                                                                      </ng-template>
                                                                <div class="time">fecha: &nbsp;{{mensaje.comentario.fecha}} &nbsp; hora: {{mensaje.comentario.hora}}</div>
                                                              </div>
                                                </ng-template>
                                              </div>
                                            </div>
                                            </div>
                                          </div>
                                        </div>
                                    
                                    <br>
                            
                                    <div class="row">
                                        <div class="col-8">
                                            <textarea class="form-control b-0 areaComentario" [placeholder]="PAGE.verCliente.escribirMensaje" name="actualComentario" [(ngModel)]="comentarioTicket">
                                            <!-- [disabled]="enviandoMensajeComentarioPopUp" -->
                                            </textarea>
                                        </div>
                                        <div class="col-4 text-right">
                                                    <input type="file" multiple="true" name="archivos" accept="image/png, image/jpg, image/jpeg" id="imagenComentario" class="btn btnEnviarComentario btn-circle btn-lg mdi mdi-paperclip" [(ngModel)]="datosImagenes" (ngModelChange)="adjuntarArchivo()">
                                                
                                            <button type="button" class="btn btnEnviarComentario btn-circle btn-lg" (click)="comentarTickets()">
                                                <i class="fa fa-paper-plane-o"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="archivosImagenes">
                                    <label>Archivos adjuntos: &nbsp;</label>
                                    <label *ngFor="let archivo of archivosImagenes">{{archivo.name}}, &nbsp;</label>
                                </div>
                                <!-- ==================== -->
                                <!-- Comentario de ticket -->
                                <!-- ==================== -->
                            <div class="modal-footer">
                                <button class="btn btnResuelto" *ngIf="usuario.rol === 'SOPORTE' && detallesEstatusEstatus==='SOPATEN'" (click)="ticketResuelto()">
                                    Resuelto
                                </button>
                                <button class="btn btnAtender" *ngIf="usuario.rol==='SOPORTE' && detallesEstatusEstatus==='AUTPEND'" (click)="atendiendoTicket() "> 
                                    Atender solicitud
                                </button>
                                <button class="btn btnEvaluar" type="button" *ngIf="usuario.rol !== 'SOPORTE' && detallesEstatusEstatus==='SOPRESU'" data-toggle="modal" data-target="#evaluacion3" data-dismiss="modal">
                                    Evaluar servicio
                                </button>
                                <!--
                                <ng-template #otro>
                                    <button class="btn btn-info waves-effect botonconfirmar " type="button " data-toggle="modal " data-target="#evaluacion " data-dismiss="modal ">
                                        Evaluar servicio
                                    </button>
                                </ng-template>
                                 -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ======================================= -->
                <!-- ========= Detalles del Ticket ========= -->
                <!-- ======================================= -->
        </div>
    </div>
</div>

<!-- =========================================== -->
                <!-- ========= Evaluación del servicio ========= -->
                <!-- =========================================== -->
                <div class="modal fade " id="evaluacion3" tabindex="-1 " role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="float float-right ">Evaluación del servicio</h4>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body ">
                                    <FORM class="form-horizontal form-material">
                                        <div class="row ">
                                            <div class="col-sm-6">
                                                <label><strong>Del 1 al 5, siendo 5 muy satisfecho. ¿Qué tan satisfecho estás con: ?</strong></label>
                                                <br>
                                                <label><strong>El servicio recibido.</strong></label>
                                                <br>
                                                <label><input type="radio" name="pregunta1" value="5" [(ngModel)]="radioPreguntaUno">5 Muy satisfecho</label>
                                                <br>
                                                <label><input type="radio" name="pregunta1" value="4" [(ngModel)]="radioPreguntaUno">4 Satisfecho</label>
                                                <br>
                                                <label><input type="radio" name="pregunta1" value="3" [(ngModel)]="radioPreguntaUno">3 Lo normal</label>
                                                <br>
                                                <label><input type="radio" name="pregunta1" value="2" [(ngModel)]="radioPreguntaUno">2 Insatisfecho</label>
                                                <br>
                                                <label><input type="radio" name="pregunta1" value="1" [(ngModel)]="radioPreguntaUno">1 Muy insatisfecho</label>
                                                <br>
                                            </div>
                                            <br>
                                            <div class="col-sm-6">
                                                <label><strong>La solución dada por el personal.</strong></label>
                                                <br>
                                                <label><input type="radio" name="pregunta2" value="5" [(ngModel)]="radioPreguntaDos">5 Muy satisfecho</label>
                                                <br>
                                                <label><input type="radio" name="pregunta2" value="4" [(ngModel)]="radioPreguntaDos">4 Satisfecho</label>
                                                <br>
                                                <label><input type="radio" name="pregunta2" value="3" [(ngModel)]="radioPreguntaDos">3 Lo normal</label>
                                                <br>
                                                <label><input type="radio" name="pregunta2" value="2" [(ngModel)]="radioPreguntaDos">2 Insatisfecho</label>
                                                <br>
                                                <label><input type="radio" name="pregunta2" value="1" [(ngModel)]="radioPreguntaDos">1 Muy insatisfecho</label>
                                                <br>
                                            </div>
                                            <br>
                                            <div class="col-sm-6">
                                                <label><strong>El tiempo de respuesta dado a tu solicitud.</strong></label>
                                                <br>
                                                <label><input type="radio" name="pregunta3" value="5" [(ngModel)]="radioPreguntaTres">5 Muy satisfecho</label>
                                                <br>
                                                <label><input type="radio" name="pregunta3" value="4" [(ngModel)]="radioPreguntaTres">4 Satisfecho</label>
                                                <br>
                                                <label><input type="radio" name="pregunta3" value="3" [(ngModel)]="radioPreguntaTres">3 Lo normal</label>
                                                <br>
                                                <label><input type="radio" name="pregunta3" value="2" [(ngModel)]="radioPreguntaTres">2 Insatisfecho</label>
                                                <br>
                                                <label><input type="radio" name="pregunta3" value="1" [(ngModel)]="radioPreguntaTres">1 Muy insatisfecho</label>
                                                <br>
                                            </div>
                                        </div>
                                    </FORM>
                                </div>
                                <div class="modal-footer">
                                    <button class="btn btn-info" data-dismiss="modal" (click)="evaluarServicio()">
                                        Enviar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- =========================================== -->
                    <!-- ========= Evaluación del servicio ========= -->
                    <!-- =========================================== -->
                </div>



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/sistemas/sistema-tickets/sistema-tickets.component.html